import React from "react";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { Button } from "../../../components/ButtonUtils";
import { InputField } from "../../../components/FormUtils";

const ModalDetails = ({ showModal, onClick, collection, setCollection }) => {
  return (
    <div className={showModal ? "fixed inset-0 z-[9999] flex items-center justify-center p-4" : "hidden"}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClick} />
      <div
        role="dialog"
        aria-modal="true"
        className="relative w-full max-w-6xl bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden"
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Hotel Details</h2>
          <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center justify-center h-8 w-8 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span className="sr-only">Close</span>
          </button>
        </div>

        <div className="p-5 overflow-y-auto max-h-[75vh]">
          <section className="mb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-3">Surroundings</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField
                props={{
                  id: "What's nearby",
                  title: "What's nearby (Comma Separated)",
                  type: "text",
                  value: collection
                    ? collection?.find((value) => value.type === "What's nearby")?.description || ""
                    : "",
                  onChange: (e) => {
                    addSurrounding({
                      category: "surroundings",
                      collection,
                      setCollection,
                      type: "What's nearby",
                      value: e.target.value,
                    });
                  },
                }}
              />
              <InputField
                props={{
                  id: "Restaurants & cafes",
                  title: "Restaurants & cafes (Comma Separated)",
                  type: "text",
                  value: collection
                    ? collection?.find((value) => value.type === "Restaurants & cafes")?.description || ""
                    : "",
                  onChange: (e) => {
                    addSurrounding({
                      category: "surroundings",
                      collection,
                      setCollection,
                      type: "Restaurants & cafes",
                      value: e.target.value,
                    });
                  },
                }}
              />
              <InputField
                props={{
                  id: "Public transport",
                  title: "Public transport (Comma Separated)",
                  type: "text",
                  value: collection
                    ? collection?.find((value) => value.type === "Public transport")?.description || ""
                    : "",
                  onChange: (e) => {
                    addSurrounding({
                      category: "surroundings",
                      collection,
                      setCollection,
                      type: "Public transport",
                      value: e.target.value,
                    });
                  },
                }}
              />
              <InputField
                props={{
                  id: "Top attractions",
                  title: "Top attractions (Comma Separated)",
                  type: "text",
                  value: collection
                    ? collection?.find((value) => value.type === "Top attractions")?.description || ""
                    : "",
                  onChange: (e) => {
                    addSurrounding({
                      category: "surroundings",
                      collection,
                      setCollection,
                      type: "Top attractions",
                      value: e.target.value,
                    });
                  },
                }}
              />
              <InputField
                props={{
                  id: "Closest airports",
                  title: "Closest airports (Comma Separated)",
                  type: "text",
                  value: collection
                    ? collection?.find((value) => value.type === "Closest airports")?.description || ""
                    : "",
                  onChange: (e) => {
                    addSurrounding({
                      category: "surroundings",
                      collection,
                      setCollection,
                      type: "Closest airports",
                      value: e.target.value,
                    });
                  },
                }}
              />
            </div>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">Facilities</h3>
            <div className="mb-4">
              <InputField
                props={{
                  id: "Languages spoken",
                  title: "Languages spoken (Comma Separated)",
                  type: "text",
                  value: collection
                    ? collection?.find((value) => value.type === "Languages spoken")?.description || ""
                    : "",
                  onChange: (e) => {
                    addSurrounding({
                      category: "facilities",
                      collection,
                      setCollection,
                      type: "Languages spoken",
                      value: e.target.value,
                    });
                  },
                }}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {Facilities.map((facility, index) => (
                <div key={index} className="w-full rounded-xl border border-gray-200 p-4">
                  <p className="text-sm font-semibold text-gray-800">{facility.title}</p>
                  <div className="mt-3 grid grid-cols-1 gap-2">
                    {facility.data.map((value, key) => {
                      const isSelected = !!collection.find((val) => val?.description === value);
                      return (
                        <button
                          type="button"
                          key={key}
                          onClick={() =>
                            isSelected
                              ? removeFacility({ collection, setCollection, value })
                              : addFacility({
                                category: "facilities",
                                collection,
                                setCollection,
                                type: facility.title,
                                value,
                              })
                          }
                          className="group rounded-lg border border-gray-200 hover:border-blue-300 px-3 py-2 flex items-center gap-2 text-left"
                        >
                          {isSelected ? (
                            <MdCheckBox className="text-blue-600 text-xl" />
                          ) : (
                            <MdCheckBoxOutlineBlank className="text-gray-500 group-hover:text-blue-600 text-xl" />
                          )}
                          <span className="text-sm text-gray-800">{value}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <div className="px-5 py-4 border-t border-gray-200 bg-gray-50">
          <div className="w-full flex justify-center">
            <Button
              props={{
                type: "button",
                title: "Finish",
                category: "default",
                action: "default",
                onClick: () => onClick(),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDetails;

const removeFacility = ({ collection, setCollection, value }) => {
  const data = collection?.filter((input) => input?.description !== value);
  setCollection([...data]);
};

const addFacility = ({ collection, setCollection, value, category, type }) => {
  const data = collection?.filter((input) => input?.description !== value);
  const inputData = collection
    ? [...data, { category, type, description: value, status: 1 }]
    : [{ category, type, description: value, status: 1 }];
  const filteredData = inputData?.filter((coll) => coll?.description !== "");
  setCollection(filteredData);
};

const addSurrounding = ({ collection, setCollection, value, category, type }) => {
  const data = collection?.filter((coll) => coll?.type !== type && coll?.description !== "");
  const inputData = collection
    ? [...data, { category, type, description: value, status: 1 }]
    : [{ category, type, description: value, status: 1 }];
  const filteredData = inputData?.filter((coll) => coll?.description !== "");
  setCollection(filteredData);
};

const Facilities = [
  { title: "Popular", data: ["Free WiFi", "Airport shuttle", "Fitness centre", "Restaurant", "Family rooms", "Spa and wellness centre", "Bar"] },
  { title: "Outdoors", data: ["Outdoor furniture", "Sun terrace", "Terrace"] },
  { title: "Activities", data: ["Happy hour", "Themed dinner nights", "Walking tours", "Evening entertainment", "Squash", "Horse riding", "Children's playground", "Casino", "Fishing", "Golf course (within 3 km)", "Tennis court"] },
  { title: "Food & Drink", data: ["Coffee house on site", "Fruits", "Wine/champagne", "Kid meals", "Special diet menus (on request)", "Snack bar", "Breakfast in the room", "Bar"] },
  { title: "Internet", data: ["WiFi is available in all areas and is free of charge."] },
  { title: "Parking", data: ["No parking available.", "Parking available."] },
  { title: "Reception services", data: ["Invoice provided", "Lockers", "Private check-in/check-out", "Concierge service", "Luggage storage", "Express check-in/check-out", "24-hour front desk"] },
  { title: "Cleaning services", data: ["Daily housekeeping", "Trouser press", "Ironing service", "Dry cleaning", "Laundry"] },
  { title: "Business facilities", data: ["Fax/photocopying", "Business centre", "Meeting/banquet facilities"] },
  { title: "Safety & security", data: ["Fire extinguishers", "CCTV outside property", "CCTV in common areas", "Smoke alarms", "Key card access", "Key access", "24-hour security", "Safety deposit box"] },
  { title: "General", data: ["Shuttle service", "Minimarket on site", "Shared lounge/TV area", "Designated smoking area", "Air conditioning", "Non-smoking throughout", "Car hire", "Packed lunches", "Lift", "Family rooms", "Barber/beauty shop", "Facilities for disabled guests", "Airport shuttle", "Non-smoking rooms", "Room service"] },
  { title: "Accessibility", data: ["Lower bathroom sink", "Higher level toilet", "Toilet with grab rails", "Wheelchair accessible"] },
  { title: "Wellness", data: ["Fitness", "Massage chair", "Body treatments", "Hair styling", "Hair colouring", "Hair cut", "Pedicure", "Manicure", "Hair treatments", "Beauty Services", "Sun loungers or beach chairs", "Massage", "Spa and wellness centre", "Fitness centre"] },
];
